import "./index.scss";

import { ReactComponent as SearchIcon } from "assets/images/icons/search.svg";
import { FC, memo, useCallback, useEffect, useState } from "react";

interface SearchProps {
  onSearch?: (value: string) => void;
  value?: string;
  placeholder?: string;
  className?: string;
  containerStyle?: any;
  isAsync?: boolean;
}

const SearchBarComponent: FC<SearchProps> = (props) => {
  const {
    containerStyle = {},
    onSearch,
    value = "",
    placeholder = "Search",
    className,
    isAsync = false,
  } = props;
  const [isFocusedInput, setIsFocusedInput] = useState(false);
  const [searchValue, setSearchValue] = useState(value);
  const ENTER_KEY = 13;

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  //#region event handlers
  const handleFocus = useCallback(() => {
    setIsFocusedInput(true);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocusedInput(false);
  }, []);

  const handleChange = useCallback(
    (v: string, invokedByEnter = false) => {
      setSearchValue(v);
      if (isAsync) {
        if (invokedByEnter) {
          onSearch && onSearch(v);
        }
      } else {
        onSearch && onSearch(v);
      }
    },
    [onSearch]
  );

  const handleKeyDown = (e) => {
    if (isAsync && e.keyCode === ENTER_KEY) {
      handleChange(searchValue, true);
    }
  };
  //#endregion event handlers

  return (
    <div
      className={`searchbar-container ${isFocusedInput ? "focus" : ""} ${className}`}
      style={containerStyle}
    >
      <SearchIcon className="search-icon" />
      <input
        placeholder={placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        value={searchValue}
      />
    </div>
  );
};

const SearchBar = memo(SearchBarComponent);
export default SearchBar;
